import axios from "axios";
import {useMemo} from "react";

const _API = {

    local: {
        getListOfEMails: (id: string | undefined) => axios.get('/storage/mission_local/MailList.json'),
        getEMail: (id: string) => axios.get('/storage/mission_local/TestEMail.json'),
        getUserPreferences: (id: string) => axios.get('/storage/mission_local/UserPreferences.json'),
        getVerseGuide: {
            systems: () => axios.get('/storage/VerseGuide/Systems.json'),
            system: (name: string) => axios.get('/storage/VerseGuide/' + name + '.json'),
        },
        getShips: (param?: string) =>
            axios.get('https://api.star-citizen.wiki/api/shipmatrix/vehicles?' + ( param ?? "" ) ),
        getShipPrices: () => axios.get('/api/ship-prices.json'),
        getIndustrialLocations: () => axios.get('https://api.uexcorp.uk/2.0/refineries_capacities'),
        getIndustrialMaterials: () => axios.get( '/api/materials.json' ),
        websocket: "ws://localhost:8090",
        voiceSocket: "ws://localhost:8095"
    },

    prod: {
        getListOfEMails: (id: string | undefined) =>
            id ? axios.get('/api/get-emails.php?mission_id=' + id)
                : axios.get('/api/get-emails.php'),
        getEMail: (id: string) => axios.get('/api/get-email.php?id=' + id),
        getUserPreferences: (id: string) => axios.get('/api/get-user-preferences.php?id=' + id),
        getVerseGuide: {
            systems: () => axios.get('/storage/VerseGuide/Systems.json'),
            system: (name: string) => axios.get('/storage/VerseGuide/' + name + '.json'),
        },
        getShips: (param?: string) =>
            axios.get('https://api.star-citizen.wiki/api/shipmatrix/vehicles?' + ( param ?? "" ) ),
        getShipPrices: () => axios.get('/api/ship-prices.json'),
        getIndustrialLocations: () => axios.get('https://api.uexcorp.uk/2.0/refineries_capacities'),
        getIndustrialMaterials: () => axios.get( '/api/materials.json' ),
        websocket: "wss://starcitizen-datapad.super-dupa-pinky.de/ws/",
        voiceSocket: "wss://starcitizen-datapad.super-dupa-pinky.de/vs/",
    }
}

export const API = window.location.port === '3000' ? _API.local : _API.prod;